import { VisibilityIcon, VisibilityOffIcon } from '@thefarmersfront/kitchen-mobile';

/**
 * 비밀번호 보기/숨기기 아이콘 컴포넌트
 */
const PasswordInputIcon = ({
  isEmpty,
  showPassword,
  setShowPassword,
}: {
  isEmpty: boolean;
  showPassword: boolean;
  setShowPassword: (showPassword: boolean) => void;
}) => {
  const handleShowPassword = (e: React.MouseEvent<SVGElement>) => {
    e.stopPropagation();

    setShowPassword(!showPassword);
  };

  if (isEmpty) {
    return null;
  }

  return showPassword ? (
    <VisibilityOffIcon color="gray400" onClick={handleShowPassword} />
  ) : (
    <VisibilityIcon color="gray400" onClick={handleShowPassword} />
  );
};

export default PasswordInputIcon;
